// extracted by mini-css-extract-plugin
export default {"wrapper":"rs-z","response":"ss-z","error":"ts-z","disabled":"us-z","buttons":"vs-z","feedbackQuestionSection":"ws-z","yesNoWrapper":"xs-z"};